import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import type { HomeFaqContent, HomeFaqItem } from '../../models/home-faq-content.model';
import { HomeFaqService } from '../../services/home-faq.service';
import { takeHomeFaqItems } from '../../utils/home-faq-banner.mapper';
import { prepareFaqTitleHtml } from '../../utils/home-faq-html.util';
import { HOME_CONTENT_MOCK } from '../../data/home-content.mock';

@Component({
  selector: 'app-home-faq',
  templateUrl: './home-faq.component.html',
  styleUrls: ['./home-faq.component.scss'],
  standalone: false,
})
export class HomeFaqComponent implements OnInit {
  eyebrow: string = String(HOME_CONTENT_MOCK.faq.eyebrow);
  titleSafe: SafeHtml = '';
  items: HomeFaqItem[] = [];
  openIndex: number | null = 0;

  constructor(
    private readonly homeFaqService: HomeFaqService,
    private readonly sanitizer: DomSanitizer
  ) {
    this.applyFallback();
  }

  ngOnInit(): void {
    this.homeFaqService.loadContent().subscribe((content) => {
      this.applyContent(content);
    });
  }

  toggleFaq(index: number): void {
    this.openIndex = this.openIndex === index ? null : index;
  }

  private applyContent(content: HomeFaqContent): void {
    this.eyebrow = content.eyebrow;
    this.titleSafe = this.sanitizer.bypassSecurityTrustHtml(content.titleHtml); // NOSONAR
    this.items = takeHomeFaqItems(content.items);
    if (this.openIndex != null && this.openIndex >= this.items.length) {
      this.openIndex = this.items.length ? 0 : null;
    }
  }

  private applyFallback(): void {
    const mock = HOME_CONTENT_MOCK.faq;
    this.eyebrow = mock.eyebrow;
    this.titleSafe = this.sanitizer.bypassSecurityTrustHtml(
      prepareFaqTitleHtml(mock.title)
    ); // NOSONAR
    this.items = mock.items.map((item, index) => ({
      orden: index + 1,
      pregunta: item.pregunta,
      respuesta: item.respuesta,
    }));
  }
}
